import {useState} from 'react'
import {useCentral} from '../../../hooks/useCentral'
import {SelectModel} from '../model'
import {getProfile} from '../services'
const useProfile = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [profiles, setProfiles] = useState<SelectModel[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const updateDataPermissions = (rowData: any) => {
    let newDataPermission = [...rowData]
    let objectCurrent = {
      ...currentTabItem,
      aditionalInformation: {
        ...currentTabItem.aditionalInformation,
        profile: {
          ...currentTabItem?.aditionalInformation?.profile,
          byPermission: {
            ...currentTabItem?.aditionalInformation?.profile?.byPermission,
            dataPermission: newDataPermission,
          },
        },
      },
    }

    changeCurrentTabItem(objectCurrent)
  }
  const getDataPermission = (rowData: any) => {
    let data = currentTabItem.aditionalInformation?.profile?.byPermission?.dataPermission ?? []
    let datatemp = [...data]
    if (data.length > 0) {
      let id = rowData.id
      let action = rowData.flagActions
      const newData = data.map((item) => (item.id === id ? {...item, flagActions: action} : item))

      let objectCurrent = {
        ...currentTabItem,
        aditionalInformation: {
          ...currentTabItem.aditionalInformation,
          profile: {
            ...currentTabItem?.aditionalInformation?.profile,
            byPermission: {
              ...currentTabItem?.aditionalInformation?.profile?.byPermission,
              dataPermission: newData,
            },
          },
        },
      }

      changeCurrentTabItem(objectCurrent)
    }
  }

  const getProfileList = async () => {
    setLoading(true)
    try {
      const response = await getProfile({}, 1, 1000)
      let data = response.data.data
      const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
      setProfiles(mappedSites as any)
    } catch (error) {
      throw error
    } finally {
      setLoading(false)
    }
  }
  return {getDataPermission, updateDataPermissions, getProfileList, profiles}
}

export default useProfile
